import { Injectable } from "@angular/core";
import { Circle, ILatLng, Spherical, LatLng } from "@ionic-native/google-maps";

@Injectable()
export class CircleUtil {
    constructor() {
        console.log('Criado CircleUtil');
    }

    insideCircle(circle: Circle, latLng: ILatLng) {
        try {
            if (circle.getBounds().contains(latLng) && Spherical.computeDistanceBetween(circle.getCenter(), latLng) <= circle.getRadius())
                return true;
            else
                return false;
        } catch (error) {
            return false;
        }
    }

    getShortestDistanceBetween(points: ILatLng[]) {
        if (points.length <= 1) return null;

        let shorter = Spherical.computeDistanceBetween(points[0], points[1]);

        for(let i = 0; i < points.length; i++) {
            for(let j = 0; j < points.length; j++) {
                if (i == j) continue;
                let distance = Spherical.computeDistanceBetween(points[i], points[j]);
                shorter = (distance < shorter ? distance : shorter);    
            }
        }

        return shorter;
    }
}